import { useEffect, useState } from "react";
import { useAppStore } from "store";

interface CourseProgress {
	completedItems: number;
	totalItems: number;
}

export const useCourseProgress = () => {
	const { coursesStore } = useAppStore();
	const [progressBeforeUnload, setProgressBeforeUnload] = useState<CourseProgress | null>(null);

	useEffect(() => {
		const freezeProgress = () => {
			const items = coursesStore.activeCourseItems;
			const progress = {
				completedItems: items.filter((item) => item.completed).length,
				totalItems: items.length,
			};
			setProgressBeforeUnload((previous) => previous ?? progress);
		};
		const resumeProgress = () => setProgressBeforeUnload(null);

		window.addEventListener("beforeunload", freezeProgress, true);
		window.addEventListener("pageshow", resumeProgress);
		return () => {
			window.removeEventListener("beforeunload", freezeProgress, true);
			window.removeEventListener("pageshow", resumeProgress);
		};
	}, [coursesStore]);

	const { completedItems, totalItems } = progressBeforeUnload ?? {
		completedItems: coursesStore.activeCourseItems.filter((item) => item.completed).length,
		totalItems: coursesStore.activeCourseItems.length,
	};

	return {
		completedPercentage: totalItems ? (completedItems / totalItems) * 100 : 0,
		incompletedPercentage: totalItems ? ((totalItems - completedItems) / totalItems) * 100 : 0,
	};
};
